const config = {
  // API_URL: "https://www.stocksbuddy.in/",
  API_URL: process.env.REACT_APP_URL,
  CAPTCHA_VERIFICATION_ENABLED: process.env.REACT_APP_CAPTCHA_VERIFICATION,
  ADMIN_OTP_ENABLED: process.env.REACT_APP_ADMIN_OTP_ENABLED,
  API_NODE_URL : process.env.REACT_APP_API_NODE_URL,
  RECAPTCHA_SITE_KEY : process.env.REACT_APP_RECAPTCHA_SITE_KEY,
  // API_NODE_URL : "https://api.stocksbuddy.in/",
  AUTH_BACKEND: "Dummy",
  RAZORPAY_KEY_ID: process.env.REACT_RAZORPAY_KEY_ID,
  FIRE_BASE: {
    API_KEY: process.env.REACT_APP_APIKEY,
    AUTH_DOMAIN: process.env.REACT_APP_AUTHDOMAIN,
    DATABASEURL: process.env.REACT_APP_DATABASEURL,
    PROJECTID: process.env.REACT_APP_PROJECTID,
    STORAGEBUCKET: process.env.REACT_APP_STORAGEBUCKET,
    MESSAGINGSENDERID: process.env.REACT_APP_MESSAGINGSENDERID,
    APPID: process.env.REACT_APP_APPID,
    MEASUREMENTID: process.env.REACT_APP_MEASUREMENTID,
  },
  GOOGLE: {
    API_KEY: process.env.REACT_APP_GOOGLE_API_KEY,
    CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID,
    SECRET: process.env.REACT_APP_GOOGLE_SECRET_KEY,
  },
  FACEBOOK: {
    APP_ID: process.env.REACT_APP_FACEBOOK_APP_ID,
  },
};

export default config;
